import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { TimetableItemFragment } from '../../../types/planung-graphql-client-defs';
import { useTimetables } from '../../Timetable/hooks/useTimetables';

/**
 * Stundenpläne des Schuljahres, in die sich eine Version des übergebenen Plans kopieren lässt: sie
 * teilen ein Stundenraster mit ihm und enthalten alle seine Klassen.
 */
export const useValidCopyTargets = (timetable: TimetableItemFragment | null) => {
  const schoolYear = useSelectedSchoolYear();
  const { timetables } = useTimetables(schoolYear?.uuid);

  return () => {
    if (!timetables) return [];

    const originalTimeGrids = timetables
      .find((tt) => tt.uuid === timetable?.uuid)
      ?.timegridConfigs.map((config) => config.timegridUuid);

    const allTimeGrids = timetables.flatMap((tt) => tt.timegridConfigs.map((config) => config.timegridUuid));
    const otherTimeGrids = allTimeGrids.filter((uuid) => originalTimeGrids?.includes(uuid));

    const sourceTimeTableClasses = timetable?.timegridConfigs.flatMap((config) => config.classUuids);

    return timetables.filter((targetTimeTable) => {
      const timeTableTimeGrids = targetTimeTable.timegridConfigs.map((config) => config.timegridUuid);
      const targetTimeTableClasses = targetTimeTable.timegridConfigs.flatMap((config) => config.classUuids);

      return (
        // has same timeGrid
        otherTimeGrids.some((item) => timeTableTimeGrids.includes(item)) &&
        // has same  classes
        sourceTimeTableClasses?.every((item) => targetTimeTableClasses.includes(item)) &&
        // not the original timetable
        targetTimeTable.uuid !== timetable?.uuid
      );
    });
  };
};
